import { render, staticRenderFns } from "./_function.vue?vue&type=template&id=15726f32&lang=pug&"
import script from "./_function.vue?vue&type=script&lang=js&"
export * from "./_function.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports